import {
  Box,
  Button,
  SpeedDial,
  SpeedDialAction,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { useThemeMode } from "../../contexts/theme-mode";
import { colors } from "../../theme/colors";

const ZOOM_LEVELS = [50, 75, 100, 125];

// JD-293: Location selector removed — global header selector is the single source of truth.
// The key-based remount on <Content /> in App.js ensures the scheduler re-fetches on location change.
function ViewMode({ fetchRemote }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Button
          sx={{
            ml: 1,
            width: "40px",
            maxWidth: "40px",
            minWidth: "40px",
            height: "40px",
            maxHeight: "40px",
            minHeight: "40px",
            borderRadius: "6px",
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
          }}
          color="primary"
          variant="contained"
          disableElevation
          onClick={fetchRemote}
        >
          <RefreshIcon />
        </Button>
      </Box>
    </Box>
  );
}

export function ZoomWidget({ zoom, onZoomChange }) {
  const { isDark } = useThemeMode();
  const handleZoomSelect = (level) => {
    onZoomChange(level);
  };

  return (
    <SpeedDial
      ariaLabel="Zoom controls"
      sx={{
        position: "absolute",
        bottom: 20,
        right: 20,
        "& .MuiFab-primary": {
          width: 48,
          height: 48,
          backgroundColor: isDark ? colors.gold : "#1976d2",
          color: isDark ? "#000" : "#fff",
          transition: "all 0.2s ease",
        },
      }}
      icon={<ZoomInIcon sx={{ fontSize: 22 }} />}
      direction="up"
    >
      {ZOOM_LEVELS.map((level) => (
        <SpeedDialAction
          key={level}
          icon={
            <Box
              sx={{
                color: zoom === level
                  ? isDark
                    ? "#000"
                    : "#fff"
                  : isDark
                    ? "#f2f2f2"
                    : "#333",
              }}
            >
              {level}%
            </Box>
          }
          tooltipTitle={`Zoom ${level}%`}
          tooltipOpen={false}
          onClick={() => handleZoomSelect(level)}
          sx={{
            width: 46,
            height: 46,
            backgroundColor: zoom === level
              ? isDark
                ? colors.gold
                : "#1976d2"
              : isDark
                ? "#1b1b1e"
                : "#f0f0f0",
            color: zoom === level ? (isDark ? "#000" : "#fff") : undefined,
            border: "2px solid",
            borderColor: isDark ? colors.gold : "#1976d2",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: zoom === level
                ? isDark
                  ? "#b8915f"
                  : "#1565c0"
                : isDark
                  ? "#2a2a2e"
                  : "#e0e0e0",
              transform: "scale(1.1)",
            },
          }}
        />
      ))}
    </SpeedDial>
  );
}

export default ViewMode;
